/**
 * Cache for admin/companies and admin/users.
 * Prefetch on Settings link hover so data is ready when user navigates.
 */
import { apiFetch } from './authApi';
import { getApiBaseUrl } from './apiBase';

const API_BASE_URL = getApiBaseUrl();

const CACHE_TTL_MS = 60 * 1000; // 60 seconds
let _cache = null; // { companies, users, ts }

export function getAdminCache() {
  if (!_cache || Date.now() - _cache.ts > CACHE_TTL_MS) return null;
  return { companies: _cache.companies, users: _cache.users };
}

export function invalidateAdminCache() {
  _cache = null;
}

export function setAdminCache(companies, users) {
  _cache = {
    companies: companies !== undefined ? (companies || []) : (_cache?.companies ?? []),
    users: users !== undefined ? (users || []) : (_cache?.users ?? []),
    ts: Date.now(),
  };
}

/**
 * Prefetch companies and users. Call on Settings link hover.
 * Silently ignores 403 (non-dev users). Updates cache as each response arrives.
 */
export function prefetchAdminData() {
  const ts = Date.now();
  if (_cache && (ts - _cache.ts) < CACHE_TTL_MS) return; // already fresh

  apiFetch(`${API_BASE_URL}/admin/companies`)
    .then((r) => r.ok ? r.json() : null)
    .then((d) => {
      if (d?.companies) {
        _cache = { ...(_cache || {}), companies: d.companies, users: _cache?.users ?? [], ts: Date.now() };
      }
    })
    .catch(() => {});

  apiFetch(`${API_BASE_URL}/admin/users`)
    .then((r) => r.ok ? r.json() : null)
    .then((d) => {
      if (d?.users) {
        _cache = { ...(_cache || {}), companies: _cache?.companies ?? [], users: d.users, ts: Date.now() };
      }
    })
    .catch(() => {});
}
